export const ApiRoutes = {
    home : {
        image: "/front-homepage-cover",
        hot_property: "/front-popular-property",
        inquiry_form: "/front-inquiry-form"
    },
    property: {
        residential: "/front-property-residential/",
        commercial: "/front-property-commercial/",
        details: "/front-property/{id}"
    },
    blog: {
        blog: "/front-blogs",
        details: "/front-blog/{id}"
    },
    contact: {
        contact: "/front-contact-form"
    },
    search: {
        property_types: "/property-types/",
        property_type: "/property-types/by-category/{str:category_type}",
        popular_place: "/front-popularplaces",
        district: "/districts/by-city/{city_id}",
        commune: "/communes/by-district/{district_id}"
    },
}; 